"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var CustomPropTypes = _interopRequireWildcard(require("../../../constants/PropTypes"));

var _reactRedux = require("react-redux");

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _Big = _interopRequireDefault(require("UIComponents/elements/Big"));

var _SanitizedText = _interopRequireDefault(require("sanitize-text/components/SanitizedText"));

var FilterKey = _interopRequireWildcard(require("../../../constants/search/FilterKey"));

var _featuredCollections = require("../../../selectors/featuredCollections");

var _StorefrontUsageTrackerContext = _interopRequireDefault(require("../../../context/StorefrontUsageTrackerContext"));

var _ResultsSection = _interopRequireDefault(require("./ResultsSection"));

var _ResultsSectionHeader = _interopRequireDefault(require("./ResultsSectionHeader"));

var getI18nKey = function getI18nKey(collection, key) {
  return "appMarketplace.amplify." + collection.toLowerCase() + "." + key;
};

var AmplifyHeaderSection = function AmplifyHeaderSection(_ref) {
  var filters = _ref.filters,
      sanitize = _ref.sanitize;
  var collection = filters[FilterKey.COLLECTION];

  var _useContext = (0, _react.useContext)(_StorefrontUsageTrackerContext.default),
      trackBeforeUnloadInteraction = _useContext.trackBeforeUnloadInteraction;

  var sectionRef = (0, _react.useRef)();
  var validCollections = (0, _reactRedux.useSelector)(_featuredCollections.getValidFeaturedCollectionsResultsHeaders);
  var isFeaturedCollection = (0, _react.useMemo)(function () {
    return collection && validCollections.some(function (collectionConfig) {
      return collectionConfig.get('collection') === collection;
    });
  }, [collection, validCollections]);
  var trackClickInteraction = (0, _react.useCallback)(function (event) {
    var action = event.target.getAttribute('data-usage-action');

    if (action) {
      trackBeforeUnloadInteraction(action, {
        section: "amplify-header::" + collection + "::static"
      }, 'storefront-amplify-header-interaction');
    }
  }, [collection, trackBeforeUnloadInteraction]);
  (0, _react.useEffect)(function () {
    var el = sectionRef.current;

    if (el) {
      el.addEventListener('click', trackClickInteraction);
      return function () {
        return el.removeEventListener('click', trackClickInteraction);
      };
    }

    return function () {};
  }, [trackClickInteraction]);

  if (!isFeaturedCollection) {
    return null;
  }

  return _react.default.createElement(_ResultsSection.default, {
    ref: sectionRef
  }, _react.default.createElement(_ResultsSectionHeader.default, {
    className: "m-bottom-2",
    title: _react.default.createElement(_FormattedMessage.default, {
      message: getI18nKey(collection, 'collection.titleText')
    })
  }), _react.default.createElement(_Big.default, null, sanitize ? _react.default.createElement(_SanitizedText.default, {
    body: _I18n.default.html(getI18nKey(collection, 'collection.subheadingText'))
  }) : _react.default.createElement(_FormattedHTMLMessage.default, {
    message: getI18nKey(collection, 'collection.subheadingText')
  })));
};

AmplifyHeaderSection.propTypes = {
  filters: CustomPropTypes.storefrontFilters.isRequired,
  sanitize: _propTypes.default.bool
};
AmplifyHeaderSection.defaultProps = {
  sanitize: false
};
var _default = AmplifyHeaderSection;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/storefront/results/AmplifyHeaderSection.js
// module id = 901
// module chunks = 209 210 211 212